import React, { useState } from 'react';
import moment from 'moment';
import SliderPartialRequest from './SliderPartialRequest';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import VtoPreviewModal from './VtoPreviewModal';
import { RequestTypes } from '../../../Enums';

/**
 * @typedef {import('./SliderPartialRequest').SliderPartialRequestProps} SliderPartialRequestWithLabelProps
 *
 */

export const sliderLabelProps = {
    backgroundColor: '#1a518a',
    color: '#FFF',
    textAlign: 'center',
    padding: '10px 0',
};

/**
 *
 * @param {SliderPartialRequestWithLabelProps & {employeeSchedule?: Array<{startDateTime: Date, endDateTime: Date}>; color?: string; managerSettingEntityId?: number; }} param0
 */
const SliderPartialRequestWithLabel = ({
    storeData = {},
    shifts,
    handleChange,
    selectedPartial,
    onSelectionInvalid,
    requestType,
    selectedPartialStartDate = null,
    selectedPartialEndDate = null,
    isReadOnly = false,
    employeeSchedule = [],
    color,
    managerSettingEntityId,
}) => {
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [currentPartialDates, setCurrentPartialDates] = useState({
        startDate: selectedPartialStartDate,
        endDate: selectedPartialEndDate
    });

    // Wrap handleChange to capture the partial dates
    const wrappedHandleChange = (e, val, shifts, requestType) => {
        if (handleChange) {
            handleChange(e, val, shifts, requestType);
        }
        // Update current partial dates when slider changes
        if (shifts && shifts.length > 0 && val && val.length === 2) {
            const shift = shifts[0];
            const startDate = moment.utc(shift.startDateTime);
            let newStartDate = moment.utc(startDate).add(val[0], 'm')
            let newEndDate = moment.utc(startDate).add(val[1], 'm')
            setCurrentPartialDates({ startDate: newStartDate, endDate: newEndDate });
        }
    };

    const isVTO = requestType === RequestTypes.voluntaryTimeOff;
    const showPreviewButton = false;//isVTO && !isReadOnly && shifts && shifts.length > 0;

    return (
        <Grid container>
            <Grid item xs={12} style={{ padding: '0 20px' }}>
                <SliderPartialRequest
                    shifts={shifts}
                    storeData={storeData}
                    requestType={requestType}
                    handleChange={wrappedHandleChange}
                    onSelectionInvalid={onSelectionInvalid}
                    selectedPartialStartDate={selectedPartialStartDate}
                    selectedPartialEndDate={selectedPartialEndDate}
                    isReadOnly={isReadOnly}
                    employeeSchedule={employeeSchedule}
                    color={color}
                />
            </Grid>
            <Grid item xs={12} style={sliderLabelProps}>
                {selectedPartial}
            </Grid>
            {showPreviewButton && (
                <Grid item xs={12} style={{ padding: '10px 20px', textAlign: 'center' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => setIsPreviewOpen(true)}
                        size="small"
                    >
                        Preview result
                    </Button>
                </Grid>
            )}
            {isVTO && (
                <VtoPreviewModal
                    open={isPreviewOpen}
                    onClose={() => setIsPreviewOpen(false)}
                    managerSettingEntityId={managerSettingEntityId}
                    partialStartDate={currentPartialDates.startDate}
                    partialEndDate={currentPartialDates.endDate}
                />
            )}
        </Grid>
    );
}

export default SliderPartialRequestWithLabel;
